import React from 'react';
import { ScrollReveal } from './ScrollReveal';
import { Target, Package, Megaphone, ShoppingCart, TrendingUp } from 'lucide-react';
import { SectionCTA } from './SectionCTA';
export function ProgramOverview() {
  const features = [{
    icon: <Target className="w-6 h-6 text-cyan-400" data-id="element-235" />,
    text: 'Detectar una oportunidad real de mercado'
  }, {
    icon: <Package className="w-6 h-6 text-purple-400" data-id="element-236" />,
    text: 'Crear tu producto digital en días'
  }, {
    icon: <Megaphone className="w-6 h-6 text-pink-400" data-id="element-237" />,
    text: 'Construir una oferta clara e irresistible'
  }, {
    icon: <ShoppingCart className="w-6 h-6 text-green-400" data-id="element-238" />,
    text: 'Lanzar usando redes sociales como canal'
  }, {
    icon: <TrendingUp className="w-6 h-6 text-amber-400" data-id="element-239" />,
    text: 'Cerrar tus primeras ventas paso a paso'
  }];
  return <section className="py-20 px-4 bg-[#050510] relative overflow-hidden" data-id="element-240">
      {/* Decorative background */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-purple-900/10 rounded-full blur-[120px]" data-id="element-241" />

      <div className="container mx-auto max-w-6xl relative z-10" data-id="element-242">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-243">
          <ScrollReveal direction="right" data-id="element-244">
            <h2 className="text-4xl md:text-5xl font-bold mb-6 leading-tight" data-id="element-245">
              EL ARTE DE <br data-id="element-246" />
              <span className="text-gradient" data-id="element-247">
                MONETIZAR TUS REDES SOCIALES
              </span>
            </h2>
            <p className="text-xl text-gray-400 mb-8" data-id="element-248">
              Es un sistema práctico de 15 días diseñado para llevarte de cero a
              tu primera venta.
            </p>
            <div className="h-1 w-20 bg-cyan-500 rounded-full" data-id="element-249" />
          </ScrollReveal>

          <div className="space-y-4" data-id="element-250">
            {features.map((feature, index) => <ScrollReveal key={index} delay={index * 0.1} direction="left" width="100%" data-id="element-251">
                <div className="glass-card p-4 rounded-xl flex items-center gap-4 hover:bg-white/10 transition-colors duration-300" data-id="element-252">
                  <div className="bg-white/5 p-3 rounded-lg" data-id="element-253">
                    {feature.icon}
                  </div>
                  <span className="text-lg font-medium text-gray-200" data-id="element-254">
                    {feature.text}
                  </span>
                </div>
              </ScrollReveal>)}
          </div>
        </div>

        <SectionCTA headline="Comienza tu transformación en 15 días" buttonText="EMPEZAR AHORA — $16.39" data-id="element-255" />
      </div>
    </section>;
}